module.exports = __webpack_public_path__ + "static/media/logo-standalone-white.ebecaed2.svg";